import { memo, useCallback, useMemo } from "react";
import { Button } from "../button";
import { useGetSSORedirectionUrl } from "../../hooks/user/mutation";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { SSO_API_ERRORS } from "../../constants/common";
import { AlertTriangle } from "lucide-react";

const LoginWithSSOCard = ({ error }: { error: string | null }) => {
  const { t } = useTranslation();

  const {
    mutateAsync: GetSSORedirectionUrl,
    isPending: isGetSSORedirectionUrlLoading,
  } = useGetSSORedirectionUrl();

  const handleSSORedirection = useCallback(async () => {
    try {
      const res = await GetSSORedirectionUrl();

      window.location.href = res || "";
    } catch (error) {
      toast.error(t("somethingWentWrong"));
    }
  }, [GetSSORedirectionUrl, t]);

  const ssoErrorMap: Record<SSO_API_ERRORS, string> = useMemo(
    () => ({
      [SSO_API_ERRORS.SSO_EXCHANGE_FAILED]: t("ssoExchangeFailed"),
      [SSO_API_ERRORS.SSO_AUTH_FAILED]: t("ssoAuthFailed"),
      [SSO_API_ERRORS.SSO_UNKNOWN]: t(
        "somethingWentWrongDuringLoginPleaseTryAgainLater",
      ),
    }),
    [t],
  );

  return (
    <div className="flex flex-col items-center justify-center gap-1">
      <div className="flex flex-col items-center justify-center">
        {error ? ssoErrorMap[error as SSO_API_ERRORS] ? (
          <div className="flex items-center text-[#DC3545] gap-2">
            <AlertTriangle className="w-[15px]" />
            <p className="font-bold text-xs text-center">
              {t(ssoErrorMap[error as SSO_API_ERRORS])}
            </p>
          </div>
        ) : (
          <p className="text-[#DC3545] font-bold text-xs text-center">
            {t("somethingWentWrongDuringLoginPleaseTryAgainLater")}
          </p>
        ) : null}
      </div>

      <Button
        isLoading={isGetSSORedirectionUrlLoading}
        onClick={handleSSORedirection}
        className="bg-black text-white max-w-max mx-auto px-6 sm:px-10 !text-base tracking-wider hover:bg-black rounded-xl"
      >
        {t("loginWith")} {t("mofaShort")} {t("account")}
      </Button>
    </div>
  );
};

export default memo(LoginWithSSOCard);
